import React from "react";
import { cn } from "../../utils/cn";

export const Input = React.forwardRef(({
  className,
  type = "text",
  error,
  icon: Icon,
  disabled,
  ...props
}, ref) => {
  return (
    <div className="relative w-full">
      {Icon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-urb-text-muted">
          {typeof Icon === "function" || typeof Icon === "object" ? (
            <Icon className="w-4 h-4" />
          ) : (
            <i className={Icon} />
          )}
        </div>
      )}
      <input
        ref={ref}
        type={type}
        disabled={disabled}
        className={cn(
          "w-full bg-urb-dark-surface border border-urb-border text-white text-sm rounded-lg px-3.5 py-2.5 transition-colors placeholder:text-urb-text-muted/60 focus:outline-none focus:border-urb-primary focus:ring-1 focus:ring-urb-primary/30 disabled:opacity-50 disabled:cursor-not-allowed",
          Icon && "pl-10",
          error && "border-red-500/80 focus:border-red-500 focus:ring-red-500/20",
          className
        )}
        {...props}
      />
      {error && typeof error === "string" && (
        <span className="text-xs text-red-400 mt-1 block">{error}</span>
      )}
    </div>
  );
});

Input.displayName = "Input";
export default Input;
